// Import 3rd-party dependencies
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IClockFavoritesTabData } from '@app/hub/world-clock/clock-favorites-tab/clock-favorites-tab.component';
import { IClockSettingsTabData } from '@app/hub/world-clock/clock-settings-tab/clock-settings-tab.component';

// Import project-specific dependencies
import { IClockSettings } from '@app/services/user-profile/user-profile.service';
import { CLOCK_DIALOG_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-clock-dialog',
  templateUrl: './clock-dialog.component.html',
  styleUrls: ['./clock-dialog.component.css']
})
export class ClockDialogComponent implements OnInit {
  // Class attributes
  settings: IClockSettings;

  consts = CLOCK_DIALOG_COMPONENT_CONSTS;

  // Class methods
  constructor(
    public dialogRef: MatDialogRef<ClockDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IClockSettings
  ) {}

  ngOnInit(): void {
    this.settings = JSON.parse(JSON.stringify(this.data)) as IClockSettings;
  }

  onSettingsChanged(event: IClockSettingsTabData): void {
    if (event) {
      this.settings.dateFormat = event.dateFormat;
      this.settings.timeFormat = event.timeFormat;
      this.settings.showDayOfWeek = event.showDayOfWeek;
    }
  }

  onFavoritesChanged(event: IClockFavoritesTabData): void {
    if (event) {
      this.settings.favorites = event.favorites;
      this.settings.recent = event.recents;
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close(this.settings);
  }
}
